export default function LoadingSpinner({ variant = 'page', size = 'md' }) {
  const sizeMap = { sm: 'h-4 w-4', md: 'h-8 w-8', lg: 'h-16 w-16' }
  const spinnerSize = sizeMap[size] || sizeMap.md

  if (variant === 'page') {
    return (
      <div className="min-h-screen bg-color-bg flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className={`${spinnerSize} relative`}>
            <div className="absolute inset-0 rounded-full border-4 border-color-primary/20" />
            <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-color-primary animate-spin" />
          </div>
          <p className="text-color-primary/60 text-sm font-medium animate-pulse">Loading...</p>
        </div>
      </div>
    )
  }

  if (variant === 'button') {
    return (
      <div className={`${sizeMap.sm} relative inline-block`}>
        <div className="absolute inset-0 rounded-full border-2 border-white/20" />
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-white animate-spin" />
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center p-8">
      <div className={`${spinnerSize} relative`}>
        <div className="absolute inset-0 rounded-full border-4 border-color-primary/20" />
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-color-primary animate-spin" />
      </div>
    </div>
  )
}
